module.exports = __webpack_public_path__ + "img/icons-book.b2c90336.png";